import { GetCookie } from "./GetCookie";

export const GetReferrer = () => {
	const referrer = window?.location?.href;
	const referrer2 = GetCookie("referer2");
	return [referrer, referrer2];
};
